import { useTranslation } from "react-i18next";

/**
 * Токены, которыми торгует робот, — ряд чипов у названия.
 *
 * Список приходит с бэкенда готовым (`RobotCard.assets`): разбирать строку
 * через запятую на фронте запрещает правило ТЗ №5, да и «BTC/USDT» тогда
 * рассыпалось бы по слэшу.
 *
 * Хвост «+N» вместо переноса. Строка каталога и без того подросла против
 * макета (`Robot · Anchor`, 20:13) — в неё добавились социальные цифры и
 * ставка комиссии, — и отдавать ей ещё одну высоту под токены нельзя: список
 * читается сравнением, а сравнивать удобно строки одинаковой высоты. Токенов у
 * робота бывает четыре и больше, так что предел здесь обязателен.
 */
export function AssetChips({
  assets,
  max = 3,
  color,
}: {
  assets: string[];
  max?: number;
  color?: string;
}) {
  const { t } = useTranslation();
  if (assets.length === 0) return null;

  const shown = assets.slice(0, max);
  const hidden = assets.length - shown.length;

  return (
    <span className="flex flex-wrap items-center gap-1" aria-label={t("robots.assets")}>
      {shown.map((asset) => (
        <span
          key={asset}
          className="rounded-md bg-background-raised px-1.5 py-0.5 text-micro font-semibold tracking-wide text-text-secondary"
          style={color ? { color } : undefined}
        >
          {asset}
        </span>
      ))}
      {hidden > 0 ? (
        <span className="text-micro font-semibold text-text-tertiary">
          {t("robots.assetsMore", { count: hidden })}
        </span>
      ) : null}
    </span>
  );
}
